import api from '@/api'
import storage from '@/plugins/storage'
import router from '@/router'
import config from '@/config'

export default {
    weixinLoginService({state}) {
        api.login
            .getWechatInfo()
            .then(({appId, state, scope}) => {
                const {redirectUrl} = config
                let redirect_uri = `${redirectUrl}/#/service-center-login-callback`
                let src = `https://open.weixin.qq.com/connect/qrconnect?appid=${appId}&scope=${scope}&redirect_uri=${encodeURIComponent(redirect_uri)}&state=${state}&login_type=jssdk&self_redirect=default&style=black`
                // Web 端微信登录接口
                const container = document.querySelector('#weixin-qrcode')
                if (!container) {
                    return
                }
                const iframe = document.createElement('iframe')
                iframe.src = src
                iframe.frameBorder = '0'
                iframe.allowTransparency = 'true'
                iframe.scrolling = 'no'
                iframe.width = '300px'
                iframe.height = '400px'
                iframe.setAttribute(
                    'sandbox',
                    'allow-same-origin allow-top-navigation allow-forms allow-scripts'
                )
                container.appendChild(iframe)
            })
            .catch(e => {
                console.log('login error:', e)
            })
    },
    weixinLogin({state}) {
        api.login
            .getWechatInfo()
            .then(({appId, state, scope}) => {
                const {redirectUrl} = config
                let redirect_uri = `${redirectUrl}/#/login-callback`
                // Web 端微信登录接口
                const container = document.querySelector('#weixin-qrcode')
                if (!container) {
                    return
                }
                let src = `https://open.weixin.qq.com/connect/qrconnect?appid=${appId}&scope=${scope}&redirect_uri=${encodeURIComponent(redirect_uri)}&state=${state}&login_type=jssdk&self_redirect=default&style=black&href=${location.origin}/wechatCss.css`
                const iframe = document.createElement('iframe')
                iframe.src = src
                iframe.frameBorder = '0'
                iframe.allowTransparency = 'true'
                iframe.scrolling = 'no'
                iframe.width = '300px'
                iframe.height = '400px'
                iframe.setAttribute(
                    'sandbox',
                    'allow-same-origin allow-top-navigation allow-forms allow-scripts'
                )
                container.appendChild(iframe)
            })
            .catch(e => {
                console.log('login error:', e)
            })
    },
    //知识库激活绑定账号的操作
    weixinActiveLogin({state}) {
        api.login
            .getWechatInfo()
            .then(({appId, state, scope}) => {
                const {redirectUrl} = config
                let redirect_uri = `${redirectUrl}/#/service-center-active-callback`
                let src = `https://open.weixin.qq.com/connect/qrconnect?appid=${appId}&scope=${scope}&redirect_uri=${encodeURIComponent(redirect_uri)}&state=${state}&login_type=jssdk&self_redirect=default&style=black`
                window.open(src)
            })
            .catch(e => {
                console.log('login error:', e)
            })
    },
    getUserInfoInLoginCallback({commit, dispatch}, {code, state,path}) {
        api.login.wechatLogin({code, state})
            .then(data => {
                dealData({commit, dispatch}, data,path)
            })
            .catch(e => {
                // 未登陆成功
                router.app.$Message.error('Alpha 用户专享的线上课程，只等你的加入！')
                router.push({name: 'LoginConcat'})
                console.log('login callback error: ', e)
            })
    },
    quit({commit}, pathObj) {
        commit('delAppToken')
        commit('delUserInfo')
        // 退出以后重新刷新一下当前页面
        router.push(pathObj&&pathObj.path||'/login')
        window.location.reload();
    },
    loginByTicket({commit, dispatch}, {t, p}) {
        api.login.loginByTicket({ticket: t}, {ignoreAuthentication: true})
            .then(data => {
                const {verified, dimission, userDTO: {id}} = data
                // 验证通过
                if (verified && !dimission) {
                    // TODO 调用接口获取到用户信息，并进行记录
                    api.login.loginByUserId({outSideId: id}).then(data => {
                        dealData({commit, dispatch}, data, '/' + p)
                    }).catch(e => {
                        router.push({name: 'Login'})
                    })
                } else {
                    router.app.$Message.error('登陆失败，请重新登陆')
                    router.push({name: 'Login'})
                }
            })
            .catch(e => {
                router.app.$Message.error('登陆失败，请重新登陆')
                router.push({name: 'Login'})
                console.log('login by ticket error: ', e)
            })
    },
    checkUser({commit, dispatch}, data) {
        let p = data.p
        api.login.loginByUserId({outSideId: data.userId}).then(data => {
            dealData({commit, dispatch}, data, p || '/home')
        }).catch(e => {
            router.app.$Message.error('登陆失败，请重新登陆')
            router.push({name: 'Login'})
            console.log('login by other user error: ', e)
        })
    },
    // getSms ({ commit }, phone) {
    //   return api.login.getSms({}, { params: { phone } })
    // },
    // smsLogin ({ commit }, data) {
    //   api.login.smsLogin(data).then(res => {
    //     const {
    //       officeName,
    //       jwtTokenDTO: { token },
    //       userDTO: { userId, userName, avatar, phone },
    //     } = res

    //     // 本地存储缓存 token 和 userinfo
    //     sessionStorage.setItem('verify-md5', token)
    //     sessionStorage.setItem('userinfo', JSON.stringify({
    //       id: userId,
    //       name: userName,
    //       officeName,
    //       avatar,
    //     }))

    //     commit('setLogin', true)
    //     commit('setUserInfo', { id: userId, name, officeName, avatar, phone })
    //     let channel = 'default'
    //     api.login.loginlog({}, { params: { channel } }).finally(res => {
    //       router.push('/')
    //     })
    //   }).catch(() => {
    //     router.app.$Message.error('Alpha 用户专享的法学院，只等你的加入！')
    //     router.push({ name: 'LoginConcat' })
    //   })
    // },
    // 设置系统配置
    getSystemConfig({commit}) {
        api.login.getSystemConfig({}, {paths: {keyConfig: 'weChatOrange'}}).then((data) => {
            commit('setSystemConfig', {key: 'weChatOrange', value: data})
        })
    },
    getNoRenewalsConfig({commit}) {
        api.login.getSystemConfig({}, {paths: {keyConfig: 'noRenewals'}}).then((data) => {
            commit('setNoRenewalsConfig', {key: 'noRenewals', value: data})
        })
    },
    sendMsg({commit, dispatch}, data) { // 发短信
        api.login.sendMsg({}, {paths: {phone: data.phone}});
    },
}

function dealData({commit, dispatch}, data, path) {
    if (data) {
        const {token} = data
        storage.set('token', token)
        commit('setLogin', true)
        // 获取用户信息并设置
        let userinfo = data
        api.user.getUserInfo().then(data => {
            data.id = data.userId
            data.name = data.userName
            commit('setUserInfo', Object.assign(userinfo, data))
        })
        let channel = 'default'
        // 存储判断用户登陆信息
        api.login.loginlog({}, {params: {channel}}).finally(() => {
            router.push(path || storage.get('cacheUrl') || '/')
            if (path == "/service-center/all") {
				setTimeout(() => {
					window.location.reload();
				}, 200);
			}
        })
        // 判断是否绑定alpha
        api.home.getIsBindAlpha().then(data => {
            storage.set('isBindAlpha', data)
            commit('setIsBindAlpha', data || false)
        })
    }
}
